import type { ControllerRenderProps, FieldError } from "react-hook-form";
import { TextField } from "@/components";
import type { ReactNode } from "react";
import type { SxProps } from "@mui/material";

export interface FormTextFieldProps {
    field: ControllerRenderProps;
    error?: FieldError;
    placeholder?: string;
    endAdornment?: ReactNode;
    label?: string;
    sx?: SxProps;
    className?: string;
    autoFocus?: boolean;
}

export function FormTextField({ field, error, placeholder, endAdornment, autoFocus, className }: FormTextFieldProps) {
    return (
        <TextField
            {...field}
            error={Boolean(error)}
            placeholder={placeholder}
            autoFocus={autoFocus}
            className={className}
            endAdornment={endAdornment}
        />
    );
}
